export const MAX_FILE_SIZE = 4_000_000
